import Signup from '@/components/AffiliatorSignup';
import { RouteType } from '@/Routes';
import { lazy } from 'react';
import { Route } from 'react-router';

const SignupIndex = lazy(() => import('@/pages/agent/signup'));
const SignupComplete = lazy(() => import('@/pages/agent/signup/complete'));
const SignupEmailAuth = lazy(() => import('@/pages/agent/signup/email_auth'));
const MyPagePartnerInfo = lazy(() => import('@/pages/agent/partner_info'));
const MypageResourceDownload = lazy(
  () => import('@/pages/agent/resource_download')
);
const MyPagePerformance = lazy(() => import('@/pages/agent/performance'));
const Login = lazy(() => import('@/pages/agent/login'));
const MyPage = lazy(() => import('@/pages/agent/mypage'));
const MyPageAbout = lazy(() => import('@/pages/agent/about'));
const AgentEdit = lazy(() => import('@/pages/agent/edit'));
const AgentBankEdit = lazy(() => import('@/pages/agent/bank/edit'));
const AgentUser = lazy(() => import('@/pages/agent/users'));

const signupRoutes: RouteType[] = [
  { path: '', component: SignupIndex },
  { path: 'email_auth', component: SignupEmailAuth },
  { path: 'complete', component: SignupComplete },
];

const mypageRoutes: RouteType[] = [
  { path: 'performance', component: MyPagePerformance },
  { path: 'partner_info', component: MyPagePartnerInfo },
  { path: 'about', component: MyPageAbout },
  { path: 'resource_download', component: MypageResourceDownload },
  { path: 'edit', component: AgentEdit },
  { path: 'bank/edit', component: AgentBankEdit },
  { path: 'users', component: AgentUser },
];

const ServerAgent: RouteType[] = [
  {
    path: '/agent/signup',
    render: ({ match: { url } }) => {
      return (
        <Signup>
          {signupRoutes.map((route, key) => (
            <Route
              exact
              path={`${url}/${route.path}`}
              component={route.component}
              key={key}
            />
          ))}
        </Signup>
      );
    },
  },
  { path: '/agent/login', component: Login },
  { path: '/agent', component: MyPage },
  {
    path: '/agent/:type(performance|promotion_code|partner_info|about|resource_download|edit|bank/edit|users|monitoring)',
    render: () => (
      <MyPage>
        {mypageRoutes.map((route, key) => (
          <Route
            exact
            path={`/agent/${route.path}`}
            component={route.component}
            key={key}
          />
        ))}
      </MyPage>
    ),
  },
];

export default ServerAgent;
